// src/hooks/useNewArrivals.js
import { useState, useEffect } from 'react';
import { db } from '../services/firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { useBooks } from './useBooks';

export const useNewArrivals = () => {
  const { books: allBooks, loading: booksLoading } = useBooks();
  const [newArrivalIds, setNewArrivalIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        const q = query(collection(db, 'newArrivals'), orderBy('addedAt', 'desc'));
        const snapshot = await getDocs(q);
        const ids = snapshot.docs.map(doc => doc.data().bookId);
        setNewArrivalIds(ids);
      } catch (error) {
        console.error('Error fetching new arrivals:', error);
        setNewArrivalIds([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNewArrivals();
  }, []);

  // Match IDs with full book data
  const newArrivalBooks = allBooks
    .filter(book => newArrivalIds.includes(book.id))
    // Preserve the order from Firestore (most recently added first)
    .sort((a, b) => {
      const indexA = newArrivalIds.indexOf(a.id);
      const indexB = newArrivalIds.indexOf(b.id);
      return indexA - indexB;
    });

  return { books: newArrivalBooks, loading: loading || booksLoading };
};